import React from "react";
import { Show, SimpleShowLayout, TextField, DateField, RichTextField } from 'react-admin';

export const LocalVaultShow = (props) => (
	<Show {...props}>
		<SimpleShowLayout>
			<TextField source="name" />
			<TextField source="keyuuid" />
			<TextField source="type" />
		</SimpleShowLayout>
	</Show>
);